import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * Opération custom `POST /imports/{id}/plan/mapping` : persiste le mapping des calques
 * (`layerMapping`) et l'association catégorie -> PlaceType (`categoryPlaceTypeMapping`)
 * dans les informations d'import. Étape préalable à l'aperçu.
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { layerMapping, categoryPlaceTypeMapping } })`.
 */
@doc.path('/imports/{id}/plan/mapping')
export default class DxfMappingModel extends MapServiceModel {
}
